export const FETCH_GOLF_LEADERBOARD = 'FETCH_GOLF_LEADERBOARD';
export const FETCH_GOLF_LEADERBOARD_FETCHING = 'FETCH_GOLF_LEADERBOARD_FETCHING';
export const FETCH_GOLF_LEADERBOARD_SUCCESS = 'FETCH_GOLF_LEADERBOARD_SUCCESS';
export const FETCH_GOLF_LEADERBOARD_FAIL = 'FETCH_GOLF_LEADERBOARD_FAIL';
